import script from "./remoteControlView.vue?vue&type=script&lang=tsx"
export * from "./remoteControlView.vue?vue&type=script&lang=tsx"

import "./remoteControlView.vue?vue&type=style&index=0&id=114da156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-114da156"]])

export default __exports__